import React from 'react';

import '../Report/Controls/filterpanel.css'

export default function FilterRender(props) {
  return (
    <input className="filter-item" type="search" onChange={props.setSearch} value={props.filter}
      placeholder="Filter" aria-label="Filter" />
  )  
}
